export default __webpack_public_path__ + "3c0f836d444976e8268ba5fdfedb0443.svg";